import { MediaQuery } from "@outplayed/responsive";
import Build from "components/Champions/RecommendedBuild/Build";
import ArenaBuild from "components/Champions/RecommendedBuild/ArenaBuild";
import AramMayhemBuild from "@ugg/shared/components/Champions/pages/AramMayhem/AramMayhemAugments";
import { AramMayhemDownloadAppBanner } from "components/Champions/RecommendedBuild/DownloadAppBanner/AramMayhemDownloadAppBanner";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { SPECIAL_CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";
import { FreestarInContentContainer } from "components/Ads/FreestarInContent";
import { FreestarPlacements } from "components/Ads/FreestarContainer";
import { useAdFree } from "lib/hooks/use-ad-free";

// Same foot unit as Build.tsx; Overview renders either <Build /> or this page, never both.
function AramMayhemFootAd() {
  const isAdFree = useAdFree();
  if (isAdFree) return null;

  return (
    <MediaQuery min="DESKTOP_MEDIUM" max="DESKTOP_LARGE" renderNullOnFail>
      <FreestarInContentContainer
        id="ugg-builds-leaderboard"
        showAdLabel
        showPlusLink
        ignoreSkinAd
        placement={FreestarPlacements.IabFoot1}
        unitId="fs-builds-foot1"
        slotClassName="flex items-center justify-center w-full min-h-[90px] max-h-[250px] overflow-hidden"
      />
    </MediaQuery>
  );
}

export function Overview() {
  const { page } = useChampionProfileContext();

  if (page === SPECIAL_CHAMPION_PAGES.OVERVIEW_ARENA) {
    return <ArenaBuild />;
  }

  if (page === SPECIAL_CHAMPION_PAGES.OVERVIEW_ARAM_MAYHEM) {
    return <AramMayhemBuild footAdSlot={<AramMayhemFootAd />} downloadBanner={<AramMayhemDownloadAppBanner />} />;
  }

  return <Build />;
}
